var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02533 1.16634C1.60453 0.808658 0.973433 0.859828 0.615746 1.28064C0.25806 1.70144 0.30923 2.33254 0.730037 2.69022L2.02533 1.16634ZM8.67151 8.12803L8.02386 8.88997L8.67151 9.44047L9.31916 8.88997L8.67151 8.12803ZM16.613 2.69022C17.0338 2.33254 17.085 1.70144 16.7273 1.28064C16.3696 0.859828 15.7385 0.808658 15.3177 1.16634L16.613 2.69022ZM0.730037 2.69022L8.02386 8.88997L9.31916 7.36609L2.02533 1.16634L0.730037 2.69022ZM9.31916 8.88997L16.613 2.69022L15.3177 1.16634L8.02386 7.36609L9.31916 8.88997Z",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.ffa99c4bf6864d3adb7b8dcc34d9ea38.svg";
export { ForwardRef as ReactComponent };